const isDevelopment: boolean = ['local', 'development', 'staging'].includes(
  import.meta.env.VITE_APP_ENV,
);

// SSR(front-node サーバー)実行時かどうか（Vite/Vike が注入）。
// サーバー側の error は本番でも CloudWatch に届けたいので常時出力する。
const isServer: boolean = !!import.meta.env.SSR;

type LogMethod = (...args: unknown[]) => void;

interface Logger {
  log: LogMethod;
  warn: LogMethod;
  error: LogMethod;
}

const logger: Logger = {
  log: (...args) => {
    if (isDevelopment) {
      console.log(...args);
    }
  },
  warn: (...args) => {
    if (isDevelopment) {
      console.warn(...args);
    }
  },
  // error は SSR(サーバー)では全環境で出力し CloudWatch(FireLens 経由)へ届ける。
  // ブラウザ側は本番で抑制し、エンドユーザーの devtools に機微情報(エラー詳細)を出さない。
  // log / warn はアクセスログ的な過剰出力を避けるため従来どおり開発時のみ。
  error: (...args) => {
    if (isDevelopment || isServer) {
      console.error(...args);
    }
  },
};

export default logger;
